// extracted by mini-css-extract-plugin
export default {"icon":"DeleteButton_icon__5y605","editBlock":"DeleteButton_editBlock__GmhjU","editButton":"DeleteButton_editButton__kEOFN"};